import axios from "axios";

/** What a marketplace tab opens pre-filtered on. */
export type TenderWatchFilter = {
  areaIds: string[];
  places: string[];
  cpvCodes: string[];
  /** False when this is the company presentation standing in for a bevakning. */
  isSaved: boolean;
};

/**
 * A save names only the dimensions the tab it came from owns. Leaving cpvCodes out is what
 * keeps the codes chosen on the public tab when saving from the private one.
 */
export type TenderWatchPayload = {
  areaIds: string[];
  places: string[];
  cpvCodes?: string[];
};

// The bare path: axiosHelper rewrites /api/... to /api/organizations/<slug>/..., so the
// filter is always saved against the organisation the user is looking at.
const BASE_URL = "/api/tender-watch";

class ServiceTenderWatch {
  async get(): Promise<TenderWatchFilter | null> {
    const response = await axios.get(BASE_URL);
    return response.data ?? null;
  }

  async save(payload: TenderWatchPayload): Promise<TenderWatchFilter> {
    const response = await axios.put(BASE_URL, payload);
    return response.data;
  }

  async remove(): Promise<void> {
    await axios.delete(BASE_URL);
  }
}

export const serviceTenderWatch = new ServiceTenderWatch();
